// extracted by mini-css-extract-plugin
export default {"addButton":"roomSelectionItems_addButton__4Ob90"};